var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 126,
    viewBox: "0 0 153 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6622 118.027V57.4324L65.6622 52.9086L30.7432 44.5946L31.3209 58.4595L33.2456 104.651C33.2841 105.575 33.9358 106.36 34.8375 106.567L84.6622 118.027Z",
    fill: "url(#paint0_linear_3_2449)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.054 102.473L119.145 96.038C119.736 95.6608 120.095 95.0077 120.095 94.3061V62.8337L109.824 69.4504L109.054 102.473Z",
    fill: "url(#paint1_linear_3_2449)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.095 35.3514L84.6622 57.4324L98.0135 72.5065L99.4125 74.0861C100.085 74.8451 101.21 75 102.063 74.4509L109.824 69.4504L120.095 62.8337L133.497 54.1991C134.552 53.5194 134.756 52.0609 133.929 51.1176L120.095 35.3514Z",
    fill: "url(#paint2_linear_3_2449)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6622 57.4324V118.027L98.0135 109.513V72.5065L84.6622 57.4324Z",
    fill: "url(#paint3_linear_3_2449)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6622 57.4324L120.095 35.3514L65.6622 22V52.9086L84.6622 57.4324Z",
    fill: "url(#paint4_linear_3_2449)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6622 22L30.7432 44.5946L65.6622 52.9086V22Z",
    fill: "url(#paint5_linear_3_2449)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7432 44.5946L24.4821 58.5083C23.6318 60.3977 25.7964 62.2147 27.5099 61.05L31.3209 58.4595L30.7432 44.5946Z",
    fill: "url(#paint6_linear_3_2449)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.063 74.4509C101.21 75 100.085 74.8451 99.4125 74.0861L98.0135 72.5065V109.513L109.054 102.473L109.824 69.4504L102.063 74.4509Z",
    fill: "url(#paint7_linear_3_2449)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 27,
    r: 5,
    fill: "#F2F4F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 117,
    r: 7,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 43,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 16,
    r: 4,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3_2449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0962 15.0714C80.0962 14.4797 79.6054 14 79 14C78.3946 14 77.9038 14.4797 77.9038 15.0714V24.6276L75.3905 22.171C74.9624 21.7525 74.2684 21.7525 73.8403 22.171C73.4122 22.5894 73.4122 23.2678 73.8403 23.6862L78.2249 27.9719C78.653 28.3903 79.347 28.3903 79.7751 27.9719L84.1597 23.6862C84.5878 23.2678 84.5878 22.5894 84.1597 22.171C83.7316 21.7525 83.0376 21.7525 82.6095 22.171L80.0962 24.6276L80.0962 15.0714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 28.6429C88.5 28.0511 88.0092 27.5714 87.4038 27.5714C86.7985 27.5714 86.3077 28.0511 86.3077 28.6429V29.7857C86.3077 30.3774 85.8169 30.8571 85.2115 30.8571L72.7885 30.8571C72.1831 30.8571 71.6923 30.3774 71.6923 29.7857L71.6923 28.6429C71.6923 28.0511 71.2015 27.5714 70.5962 27.5714C69.9908 27.5714 69.5 28.0511 69.5 28.6429V29.7857C69.5 31.5609 70.9723 33 72.7885 33H85.2115C87.0277 33 88.5 31.5609 88.5 29.7857V28.6429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3_2449",
    x: 46.5,
    y: -8,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3_2449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3_2449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2449",
    x1: 63.5,
    y1: 53,
    x2: 59.5,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2449",
    x1: 78.5,
    y1: 22,
    x2: 78.5,
    y2: 118.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2449",
    x1: 106.23,
    y1: 45.3649,
    x2: 114.446,
    y2: 65.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2449",
    x1: 106.23,
    y1: 45.3649,
    x2: 114.446,
    y2: 65.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_2449",
    x1: 78.5,
    y1: 22,
    x2: 78.5,
    y2: 107.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_2449",
    x1: 106.23,
    y1: 45.3649,
    x2: 114.446,
    y2: 65.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_2449",
    x1: 78.5,
    y1: 22,
    x2: 78.5,
    y2: 118.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D7177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_2449",
    x1: 106.23,
    y1: 45.3649,
    x2: 114.446,
    y2: 65.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataContainer);
export default __webpack_public_path__ + "static/media/NoDataContainer.dfcbcf0334bb6a7b6f2dc048f526523e.svg";
export { ForwardRef as ReactComponent };